import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthButton from "../TopNav/AuthButton";
import { useAuth } from "../../contexts/AuthContext"; // Import the AuthContext to access authentication state
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import TopNav from "../TopNav/TopNav"; // Import TopNav component
import Footer from "../MainPage/Footer"; // Import Footer component
import QAFeedback from "../JobSchedulePage/QAFeedback";
import { usePermissions } from "../../hooks/usePermissions";
import {
  PRODUCTION_ASSEMBLY_SCHEDULE_PATH,
  PRODUCTION_SHIPPING_PATH,
  PRODUCTION_NORTH_PRAIRIE_PATH,
  PRODUCTION_ON_TIME_DELIVERY_PATH,
  PRODUCTION_PORTAL_PATH,
  PRODUCTION_PANEL_SHOP_PATH,
  PRODUCTION_SCHEDULE_PATH,
} from "../../config/productionRoutes";

const Home = () => {
  const { isAuthenticated } = useAuth(); // Get the authentication status from the context
  const [showQAFeedback, setShowQAFeedback] = useState(false);
  const { canView, isLoading: isPermissionsLoading } = usePermissions();
  const navigationGroups = [
    {
      title: "Sales",
      items: [
        { label: "Sales Portal", to: "/sales", permission: "home.sales-portal" },
      ],
    },
    {
      title: "Apps",
      items: [
        { label: "Forms", to: "/forms", permission: "home.forms" },
        { label: "Activity Log", to: "/apps/activitylog", permission: "home.apps-portal" },
        { label: "Task Manager", to: "/apps/taskmanager", permission: "home.apps-portal", hideOnMobile: true },
        { label: "Bookings Log", to: "/apps/bookingslog", permission: "apps.bookings-log" },
        { label: "Sales Targets", to: "/apps/salesTargets", permission: "apps.sales-targets" },
      ],
    },
    {
      title: "Engineering",
      items: [
        { label: "Engineering Portal", to: "/engineering", permission: "home.engineering-tools" },
        { label: "Design Documents", to: "/engineering/design-documents", permission: "home.engineering-design-documents" },
        { label: "Controls Workspace", to: "/controls", permission: "home.controls" },
      ],
    },
    {
      title: "Production",
      items: [
        { label: "Production Portal", to: PRODUCTION_PORTAL_PATH, permission: "home.production-portal" },
        { label: "Panel Shop", to: PRODUCTION_PANEL_SHOP_PATH, permission: "home.panel-shop" },
        { label: "Production Schedule", to: PRODUCTION_SCHEDULE_PATH, permission: "home.production-schedule" },
        { label: "Assembly Schedule", to: PRODUCTION_ASSEMBLY_SCHEDULE_PATH, permission: "home.assembly" },
        { label: "Shipping", to: PRODUCTION_SHIPPING_PATH, permission: "home.shipping" },
        { label: "North Prairie", to: PRODUCTION_NORTH_PRAIRIE_PATH, permission: "home.north-prairie" },
        { label: "On Time Delivery", to: PRODUCTION_ON_TIME_DELIVERY_PATH, permission: "user.on-time-delivery" },
      ],
    },
    {
      title: "Admin",
      items: [
        { label: "Admin Portal", to: "/admin", permission: "admin.container" },
        { label: "Global Search", to: "/globalSearch", permission: "home.global-search" },
        { label: "User Home", to: "/user", permission: "home.user-home" },
      ],
    },
  ];

  const visibleNavigationGroups = navigationGroups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => canView(item.permission)),
    }))
    .filter((group) => group.items.length > 0);

  return (
    <div className="home-page">
      <TopNav /> {/* Display TopNav at the top */}
      <div className="home-content container mt-5" style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: "2.5rem", fontWeight: "bold" }}>
          Welcome to the Watertronics Portals
        </h1>
        {!isAuthenticated && (
          <>
            <p style={{ fontSize: "1.25rem" }}>
              Please log in to access your dashboard and manage your production
              data.
            </p>
            <AuthButton />
          </>
        )}
        {isAuthenticated && isPermissionsLoading && (
          <div className="text-center p-4" role="status" aria-live="polite">
            <div className="spinner-border text-primary" aria-hidden="true" />
            <p className="mt-2">Loading navigation...</p>
          </div>
        )}
        {isAuthenticated && !isPermissionsLoading && (
          <div className="row g-4 mt-4 text-start justify-content-center">
            {visibleNavigationGroups.map((group) => (
              <section key={group.title} className="col-12 col-md-6 col-xl">
                <h2 className="h5 fw-bold text-uppercase text-muted border-bottom pb-2">
                  {group.title}
                </h2>
                <div className="d-grid gap-3">
                  {group.items.map((item) => (
                    <Link
                      key={`${group.title}-${item.label}`}
                      to={item.to}
                      className={`text-decoration-none ${item.hideOnMobile ? "d-none d-md-block" : ""}`}
                    >
                      <button
                        className="btn btn-primary w-100 p-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {item.label}
                      </button>
                    </Link>
                  ))}
                </div>
              </section>
            ))}
          </div>
        )}
        {isAuthenticated && (
          <button
            className="home-qa-button btn btn-warning mt-3 p-3 mx-2"
            style={{ fontSize: "1.25rem" }}
            onClick={() => setShowQAFeedback(true)}
          >
            <i className="bi bi-clipboard-check me-2"></i>
            Submit QA Feedback
          </button>
        )}
      </div>
      
      <Footer /> {/* Display Footer at the bottom */}
      
      {/* QA Feedback Modal */}
      <QAFeedback
        show={showQAFeedback}
        onHide={() => setShowQAFeedback(false)}
        job={null}
        jobId={null}
        manualMode={true}
      />
    </div>
  );
};

export default Home;
